

import React, { useEffect, useMemo, useRef, useState } from 'react';
//  CODE FOR ONE PAGE
import LayerPanelPage from "./LayerPanelPage";
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import "@arcgis/core/assets/esri/themes/light/main.css";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Query from "@arcgis/core/rest/support/Query";
//Graphic show on map
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Graphic from "@arcgis/core/Graphic";
import LayerControlPanel from '../../componets/LayerControlPanel';

import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import Home from "@arcgis/core/widgets/Home";
import ScaleBar from "@arcgis/core/widgets/ScaleBar.js";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery.js";
import Locate from "@arcgis/core/widgets/Locate.js";
import Expand from "@arcgis/core/widgets/Expand";
import Legend from "@arcgis/core/widgets/Legend";
import Search from "@arcgis/core/widgets/Search";
import Print from "@arcgis/core/widgets/Print";
import LayerList from "@arcgis/core/widgets/LayerList.js";
import Zoom from "@arcgis/core/widgets/Zoom";
import Measurement from "@arcgis/core/widgets/Measurement";


import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { setIsDist, setIsUlb, setIsWard } from "../../store/slice/currentStageSlice";


//  CODE FOR ONE PAGE
import { FaTimes } from "react-icons/fa";
import useArcGISToken from "./useArcGISToken.js"; // Token Call
import esriConfig from "@arcgis/core/config";
import { HmacSHA384 } from 'crypto-js';
let GIStoken;
//  CODE FOR ONE PAGE

// === Sublayer Groups ===
const BASE_SERVICE_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";

const ADMIN_BOUNDARIES_SUBLAYERS = [
  { id: 1, title: "MP State", visible: false },
  { id: 2, title: "MP Division", visible: false },
  { id: 3, title: "MP District", visible: true },
  { id: 94, title: "MP ULB", visible: true },
  { id: 95, title: "MP Ward", visible: false },
  { id: 5, title: "Municipal Area", visible: false },
  { id: 7, title: "Municipal Ward", visible: false },
];

const PROPERTY_SUBLAYERS = [
  { id: 14, title: "Property", visible: false },
  { id: 15, title: "Building Footprint", visible: false },
  { id: 16, title: "Builtup Area", visible: false },
  { id: 17, title: "Slum Area", visible: false },
  { id: 39, title: "Industrial Area", visible: false },
];

const GREEN_SPACE_SUBLAYERS = [
  { id: 30, title: "Agricultural Area", visible: false },
  { id: 32, title: "Forest", visible: false },
  { id: 33, title: "Vacant Lands", visible: false },
  { id: 34, title: "Waste Lands", visible: false },
  { id: 36, title: "Open Land", visible: false },
  { id: 38, title: "Playground", visible: false },
  { id: 41, title: "Plantation", visible: false },
  { id: 42, title: "Orchyard", visible: false },
  { id: 43, title: "Park", visible: false },
];

const TRANSPORTATION_SUBLAYERS = [
  { id: 45, title: "Roads", visible: false },
  { id: 56, title: "Railway", visible: false },
  { id: 59, title: "Railway Station", visible: false },
  { id: 61, title: "Aircraft Road", visible: false },
  { id: 62, title: "Airport", visible: false },
  { id: 63, title: "Helipad", visible: false },
  { id: 64, title: "Busstand", visible: false },
];

const WATERBODIES_SUBLAYERS = [
  { id: 69, title: "Rivers", visible: false },
  { id: 70, title: "Drainage or Nala", visible: false },
  { id: 75, title: "Lake/Pond/Reservoir", visible: false },
];

const LANDMARKS_SUBLAYERS = [
  { id: 79, title: "Important Landmarks", visible: false },
];

const MASTER_PLAN_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/master_plan/MapServer";

const MASTER_PLAN_SUBLAYERS = [
  { id: 1, title: "Planning Area", visible: false },
  { id: 2, title: "Master Plan Village Boundary", visible: false },
  { id: 3, title: "Master Plan", visible: false },
];

const SAMPDA_GUIDELINE_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/sampda_guideline/MapServer";

const SAMPDA_GUIDELINE_SUBLAYERS = [
  { id: 1, title: "Sampda Guideline 2025_26", visible: false },
];

const WATER_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/watersupply_project/MapServer";

const WATER_SUBLAYERS = [
  { id: 1, title: "WTP", visible: false },
  { id: 2, title: "Intake Well", visible: false },
  { id: 3, title: "OHT", visible: false },
  { id: 4, title: "Junction", visible: false },
  { id: 5, title: "RWPM", visible: false },
  { id: 6, title: "CWPM", visible: false },
  { id: 7, title: "Distribution Line", visible: false },
];

const SEWER_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/sewerage_project/MapServer";

const SEWER_SUBLAYERS = [
  { id: 1, title: "STP", visible: false },
  { id: 2, title: "MPS", visible: false },
  { id: 3, title: "IPS", visible: false },
  { id: 4, title: "Manhole", visible: false },
  { id: 5, title: "Sewer Line", visible: false },
];

const ASSETS_URL1 = "https://urbangis.mp.gov.in/server/rest/services/temp_n/govt_assets_mis/MapServer";

const ASSETS_Central_SUBLAYERS = [
  { id: 2, title: "Central Govt Assets", visible: false },
  { id: 3, title: "State Govt Assets", visible: false },
  { id: 4, title: "Municipal Govt Assets", visible: false }
];

const BaseMapURL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/FeatureServer";

const BaseMapURL_SubLayer = [
  { id: 15, title: "plotbuildingstructure", visible: true },
  { id: 45, title: "roadcenterline", visible: true },
  { id: 56, title: "railwaycenterline", visible: true },
  { id: 75, title: "waterbodies", visible: false },
  { id: 79, title: "importantlandmarks", visible: true },

];

const MPLanduse = "https://urbangis.mp.gov.in/server/rest/services/temp_n/mp_lulc_change/MapServer";
const MPLanduse_sublayer = [
  { id: 6, title: "Landuse 2022", visible: false },
  { id: 8, title: "Landuse 2024", visible: false },
];

const StormWaterURL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/stormwater_project_data/MapServer";
const StormWaterURL_sublayer = [
  { id: 1, title: "Storm Water Drainage Line", visible: false },

];
// === Layer Groups ===

const GROUPS = [
  { url: BASE_SERVICE_URL, title: "Administrative Boundaries", sublayers: ADMIN_BOUNDARIES_SUBLAYERS },
  { url: ASSETS_URL1, title: "Government Assets", sublayers: ASSETS_Central_SUBLAYERS },
  { url: BASE_SERVICE_URL, title: "Properties", sublayers: PROPERTY_SUBLAYERS },
  { url: BASE_SERVICE_URL, title: "Green Spaces", sublayers: GREEN_SPACE_SUBLAYERS },
  { url: BASE_SERVICE_URL, title: "Transportation", sublayers: TRANSPORTATION_SUBLAYERS },
  { url: BASE_SERVICE_URL, title: "Waterbodies", sublayers: WATERBODIES_SUBLAYERS },
  { url: BASE_SERVICE_URL, title: "Landmarks", sublayers: LANDMARKS_SUBLAYERS },
  { url: MASTER_PLAN_URL, title: "Master Plan", sublayers: MASTER_PLAN_SUBLAYERS },
  { url: SAMPDA_GUIDELINE_URL, title: "Sampda Guideline", sublayers: SAMPDA_GUIDELINE_SUBLAYERS },
  { url: WATER_URL, title: "Water Supply Network", sublayers: WATER_SUBLAYERS },
  { url: SEWER_URL, title: "Sewerage Network", sublayers: SEWER_SUBLAYERS },
  { url: StormWaterURL, title: "Storm Water Network", sublayers: StormWaterURL_sublayer },
  { url: MPLanduse, title: "MP Landuse", sublayers: MPLanduse_sublayer },
];
// === END Groups ===






const baseURL = "https://urbangis.mp.gov.in/server";
// Layer definitions
const mainLayerUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";

// const WATER_URL = "";

// const WATER_SUBLAYERS = [
//     { id: 1, title: "WTP", visible: false },
//     { id: 2, title: "Intake Well", visible: false },
//     { id: 3, title: "OHT", visible: false },
//     { id: 4, title: "Junction", visible: false },
//     { id: 5, title: "RWPM", visible: false },
//     { id: 6, title: "CWPM", visible: false },
//     { id: 7, title: "Distribution Line", visible: false },
// ];

// const SEWER_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/sewerage_project/MapServer";

// const SEWER_SUBLAYERS = [
//     { id: 1, title: "STP", visible: false },
//     { id: 2, title: "MPS", visible: false },
//     { id: 3, title: "IPS", visible: false },
//     { id: 4, title: "Manhole", visible: false },
//     { id: 5, title: "Sewer Line", visible: false },
// ];


//https://urbangis.mp.gov.in/server/rest/services/temp_n/industrial_area_location/MapServer/1

const layers = {
  industrial_area_location: {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/industrial_area_location/MapServer",
    sublayerId: 1
  },
};

const layersSpc = {
  SewerSTP: {
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/sewerage_project/MapServer",
    sublayerId: 1
  },
};

//  layer End 


function MapPointDist({ isWidth, isScreenSize, isByDefaultActive }) {

  const [tabLocation, setTabLocation] = useState(false);
  const { isTheme, isBufferWidth, isToolHeight, currentStageValue, isSideBar } = useSelector((state) => state.currentStage);
  const { bufferData, selectedBuffer, setFeatureTable } = useSelector((state) => state.buffer);
  const [isScreenSize1, setIsScreenSize1] = useState(window.innerWidth <= 991);
  const dispatch = useDispatch()
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [districtCode, setDistrictCode] = useState("");
  const authData = useSelector(state => state.authToken.authData);

  const [ulbs, setUlbs] = useState([]);
  const [selectedUlb, setSelectedUlb] = useState("");
  const [ulbCode, setUlbCode] = useState("");
  const [refactive, setRefactive] = useState("0");
  const [wards, setWards] = useState([]);
  const [selectedWard, setSelectedWard] = useState("");
  const [wardCode, setWardCode] = useState("");

  const [activeSelect, setActiveSelect] = useState("area");
  const [isDrag, setIsDrag] = useState(false);


  // State for PrimeReact DataTable
  const highlightRef = useRef(null); // store the current highlight
  const [fieldsOptions, setFieldsOptions] = useState([]);
  const [fieldsOptions2, setFieldsOptions2] = useState([]);
  const [distance, setDistance] = useState(null);
  const [STPSelected, setSTPSelected] = useState(null);
  const [INDSelected, setINDSelected] = useState(null);
  const [selectedValue1, setSelectedValue1] = useState("");
  const [selectedValue2, setSelectedValue2] = useState("");
  //   NEW TOOLS 2025
  // 30 DEC 2025 
  const layerRef = useRef(null);
  const [map, setMap] = useState(null);
  const mapDiv = useRef(null);
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  // TABLE DATA
  const [tableData, setTableData] = React.useState([]);
  const [tableData2, setTableData2] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [Attributes_URL, setAttributes_URL] = useState([]);
  const [Spatial_URL, setSpatial_URL] = React.useState(false);

  const [Attributes_URLQuery, setAttributes_URLQuery] = useState([]);
  const [Spatial_URLQuery, setSpatial_URLQuery] = React.useState(false);

  //  DATA
  //  NEW STATE 
  //  BHUPEN LAYER CODE
  const [layerGroups, setLayerGroups] = useState(GROUPS);

  const toggleLayer = (groupTitle, sublayerId) => {
    const updatedGroups = layerGroups.map(group => {
      if (group.title !== groupTitle) return group;

      const updatedSublayers = group.sublayers.map(sublayer =>
        sublayer.id === sublayerId
          ? { ...sublayer, visible: !sublayer.visible }
          : sublayer
      );

      return { ...group, sublayers: updatedSublayers };
    });

    setLayerGroups(updatedGroups);
  };
  // BHUPEN LAYERS CODE

  const buildFilter = (dist_cd, ulb_cd, wardno) => {
    const conditions = [];
    if (dist_cd) conditions.push(`dist_cd = '${dist_cd}'`);
    if (ulb_cd) conditions.push(`ulb_cd = '${ulb_cd}'`);
    if (wardno) conditions.push(`wardno = '${wardno}'`);
    return conditions.length > 0 ? conditions.join(" AND ") : "1=1";
  };
  const [view, setView] = useState(null);

  // code for SQL
  // code for token 
  const token = useArcGISToken();

  useEffect(() => {

    GIStoken = token;

    if (!token) return;

    esriConfig.request.interceptors =
      esriConfig.request.interceptors.filter(
        (i) => i._isAuthInterceptor !== true
      );
    // ✅ Attach token to all requests
    esriConfig.request.interceptors.push({
      urls: "https://mpurbangis.in/server/rest/services",
      before: (params) => {
        params.requestOptions.query = {
          ...params.requestOptions.query,
          token: token,
        };
      },
    });




    if (!mapDiv.current) return;
    const mapInstance = new Map({
      basemap: "topo-vector"  // Use your desired basemap
    });

    const mapView = new MapView({
      container: mapDiv.current,  // The div where the map will render
      map: mapInstance,
      center: [77.4126, 23.2599],
      zoom: 6,
      ui: { components: ["attribution"] }
    });


    // MAP TOOLS 


    mapView.ui.add(new Home({ view: mapView }), "top-left");
    mapView.ui.add(new Zoom({ view: mapView }), "top-left");
    mapView.ui.add(new Expand({ view: mapView, content: new BasemapGallery({ view: mapView }) }), "top-left");
    mapView.ui.add(new Locate({ view: mapView, graphic: new Graphic({ symbol: { type: "simple-marker" } }) }), "top-left");
    mapView.ui.add(new ScaleBar({ view: mapView }), "bottom-right");


    // MAP TOOLS 



    // Optionally, add a default layer
    const baseLayer = new MapImageLayer({
      url: mainLayerUrl,
      sublayers: []  // No initial sublayers
    });
    mapInstance.add(baseLayer);
    layerRef.current = baseLayer;

    setMap(mapInstance);    // Set the map reference
    setView(mapView);
    AdminLayer(0);    // Set the view reference
    mapView.ui.add(new Expand({ view: mapView, content: new BasemapGallery({ view: mapView }) }), "top-Right");


    // BHUPEN FOR MAP 

    // BHUPEN FOR MAP




    return () => mapView.destroy();


    // end useEffect
  }, [token]);

  // end useEffect



  // const handleLayerChange = (e) => {

  //   const key = e.target.value;
  //   if (!map || !layers[key]) return;

  //   // Remove previous layer only
  //   if (layerRef.current) {
  //     map.remove(layerRef.current);   // Remove the old layer
  //     layerRef.current.destroy();     // Clean up the old layer
  //     layerRef.current = null;        // Reset the layer reference
  //   }



  //   const layerUrl = layers[key].url;
  //   const sublayerId = layers[key].sublayerId;
  //   // create final URL
  //   const finalUrl = `${layerUrl}/${sublayerId}`;
  //   // call fields here
  //   //setTargetLayer()
  //   const filterExpr = buildFilter(districtCode, ulbCode, wardCode);

  //   fetchFields(finalUrl, filterExpr);
  //   setAttributes_URL(finalUrl);

  //   const newLayer = new MapImageLayer({
  //     url: layers[key].url,
  //     sublayers: [
  //       {
  //         id: layers[key].sublayerId,
  //         visible: true,
  //         definitionExpression: filterExpr,
  //       },
  //     ],
  //   });

  //   map.add(newLayer);
  //   layerRef.current = newLayer;

  //   AdminLayer(0);
  //   newLayer.when(() => {
  //     if (newLayer.fullExtent) {
  //       // view.goTo(newLayer.fullExtent);
  //     }
  //   });
  // };


  const handleLayerChange = (e) => {

    const key = e.target.value;
    if (!map || !layers[key]) return;

    // 🔹 Remove previous layer
    if (layerRef.current) {
      map.remove(layerRef.current);
      layerRef.current.destroy();
      layerRef.current = null;
    }

    const layerUrl = layers[key].url;
    const sublayerId = layers[key].sublayerId;

    const finalUrl = `${layerUrl}/${sublayerId}`;

    const filterExpr = buildFilter(districtCode, ulbCode, wardCode);

    fetchFields(finalUrl, filterExpr);
    setAttributes_URL(finalUrl);

    // 🔥 Create MapImageLayer with Popup
    const newLayer = new MapImageLayer({
      url: layerUrl,
      sublayers: [
        {
          id: sublayerId,
          visible: true,
          definitionExpression: filterExpr,
          popupEnabled: true,
          popupTemplate: {
            title: "Industrial Area Details",
            content: [
              {

                type: "fields",
                fieldInfos: [
                  { fieldName: "districtname", label: "District Name" },
                  { fieldName: "ulbname", label: "ULB Name" },
                  { fieldName: "name", label: "Industrial" },

                ]
              }
            ]
          }
        }
      ]
    });

    map.add(newLayer);
    layerRef.current = newLayer;

    // 🔹 Enable popup
    view.popup.autoOpenEnabled = true;

    // 🔹 Click event (safe popup open)
    view.on("click", function (event) {
      view.hitTest(event).then(function (response) {

        const result = response.results.find(r =>
          r.graphic.layer?.type === "map-image"
        );

        if (result) {
          view.popup.open({
            location: event.mapPoint,
            features: [result.graphic]
          });
        }

      });
    });

    AdminLayer(0);

    newLayer.when(() => {
      if (newLayer.fullExtent) {
        // view.goTo(newLayer.fullExtent);
      }
    });

  };

  // field  field data
  // 
  const fetchFields = async (finalUrl, filterExpr) => {
    try {
      // Use the filterExpr in the query
      const url = `${finalUrl}/query?where=${encodeURIComponent(filterExpr)}&outFields=objectid,name ,latitude  ,longitude &returnGeometry=false&f=json`;

      const response = await fetch(url);
      const data = await response.json();

      if (data.features?.length) {
        const options = data.features.map((f, index) => ({
          sno: index + 1,
          value: f.attributes.objectid,
          label: `${index + 1}. ${f.attributes.name}`,
          lat: parseFloat(f.attributes.latitude),
          lng: parseFloat(f.attributes.longitude),
        }));

        setFieldsOptions(options);
      } else {
        setFieldsOptions([]);
      }
    } catch (error) {
      console.error("Error fetching fields:", error);
      setFieldsOptions([]);
    }
  };

  // Build Query Here


  // code for Second  rows 


  // const handleLayerChange2 = (e) => {
  //   const key = e.target.value;
  //   if (!map || !layersSpc[key]) return;

  //   // Remove previous layer only
  //   // if (layerRef.current) {
  //   //   map.remove(layerRef.current);   // Remove the old layer
  //   //   layerRef.current.destroy();     // Clean up the old layer
  //   //   layerRef.current = null;        // Reset the layer reference
  //   // }



  //   const layerUrl = layersSpc[key].url;
  //   const sublayerId = layersSpc[key].sublayerId;
  //   // create final URL
  //   const finalUrl = `${layerUrl}/${sublayerId}`;
  //   // call fields here
  //   const filterExpr = buildFilter(districtCode, ulbCode, wardCode);

  //   fetchFields2(finalUrl, filterExpr);
  //   setSpatial_URL(finalUrl);

  //   const newLayer = new MapImageLayer({
  //     url: layersSpc[key].url,
  //     sublayers: [
  //       {
  //         id: layersSpc[key].sublayerId,
  //         visible: true,
  //         definitionExpression: filterExpr,
  //       },
  //     ],
  //   });

  //   map.add(newLayer);
  //   layerRef.current = newLayer;

  //   AdminLayer(0);


  //   newLayer.when(() => {
  //     if (newLayer.fullExtent) {
  //       // view.goTo(newLayer.fullExtent);
  //     }
  //   });
  // };
  const handleLayerChange2 = (e) => {

    const key = e.target.value;
    if (!map || !layersSpc[key]) return;

    const layerUrl = layersSpc[key].url;
    const sublayerId = layersSpc[key].sublayerId;
    const finalUrl = `${layerUrl}/${sublayerId}`;

    const filterExpr = buildFilter(districtCode, ulbCode, wardCode);

    fetchFields2(finalUrl, filterExpr);
    setSpatial_URL(finalUrl);

    // 🔥 Create MapImageLayer with Popup
    const newLayer = new MapImageLayer({
      url: layerUrl,
      sublayers: [
        {
          id: sublayerId,
          visible: true,
          definitionExpression: filterExpr,
          popupEnabled: true,
          popupTemplate: {
            title: "{sc_name}",
            content: [
              {
                type: "fields",
                fieldInfos: [
                  { fieldName: "DISTRICT", label: "District" },
                  { fieldName: "ULB_NAME", label: "ULB Name" },
                  { fieldName: "pr_nm", label: "Project Name" },
                  { fieldName: "sc_name", label: "Scheme Name" },
                  { fieldName: "capacity", label: "Capacity" },
                  { fieldName: "loc_nm", label: "Location Name" },
                  { fieldName: "status", label: "status Name" }



                ]
              }
            ]
          }
        }
      ]
    });

    map.add(newLayer);
    layerRef.current = newLayer;

    // ✅ Enable popup auto open
    view.popup.autoOpenEnabled = true;

    // ✅ Safe click handler (Only add once in your app ideally)
    view.on("click", function (event) {

      view.hitTest(event).then(function (response) {

        const result = response.results.find(r =>
          r.graphic.layer?.type === "map-image"
        );

        if (result) {
          view.popup.open({
            location: event.mapPoint,
            features: [result.graphic]
          });
        }

      });

    });

    AdminLayer(0);

    newLayer.when(() => {
      if (newLayer.fullExtent) {
        // view.goTo(newLayer.fullExtent);
      }
    });

  };

  // field  field data


  //objectid ,pr_nm lat ,lng 
  const fetchFields2 = async (finalUrl, filterExpr) => {
    try {
      // Use the filterExpr in the query
      const url = `${finalUrl}/query?where=${encodeURIComponent(filterExpr)}&outFields=objectid,sc_name ,capacity, loc_nm,lat,lng&returnGeometry=false&f=json`;

      const response = await fetch(url);
      const data = await response.json();
      // ${index + 1}.  
      if (data.features?.length) {
        const options = data.features.map((f, index) => ({
          sno: index + 1,
          value: f.attributes.objectid,
          label: ` ${index + 1}.${f.attributes.sc_name}_${f.attributes.capacity}_${f.attributes.loc_nm}`,
          lat: parseFloat(f.attributes.lat),
          lng: parseFloat(f.attributes.lng),
        }));

        setFieldsOptions2(options);
      } else {
        setFieldsOptions2([]);
      }
    } catch (error) {
      console.error("Error fetching fields2:", error);
      setFieldsOptions2([]);
    }
  };


  // code for ADD DYANAMIC  and Condition 
  const [rows2, setRows2] = useState([
    { logical: "AND", field: "", operator: "", value: "" }
  ]);


  // CALCULATE DIS
  let routeGraphic = null;

  const handleRunQuery = () => {

    if (!selectedValue1 || !selectedValue2) {

      return;
    }

    const obj1 = fieldsOptions.find(
      (o) => o.value === Number(selectedValue1)
    );

    const obj2 = fieldsOptions2.find(
      (o) => o.value === Number(selectedValue2)
    );

    //
    //alert(obj2.label);

    setINDSelected(obj1.label);
    setSTPSelected(obj2.label);



    if (!obj1 || !obj2) {
      alert("Object not found");
      return;
    }

    view.goTo([
      [obj1.lng, obj1.lat],
      [obj2.lng, obj2.lat]
    ]);

    if (routeGraphic) {
      view.graphics.remove(routeGraphic);
    }

    // 🔴 Create RED polyline
    const polyline = {
      type: "polyline",
      paths: [
        [obj1.lng, obj1.lat],
        [obj2.lng, obj2.lat]
      ]
    };

    const lineGraphic = new Graphic({
      geometry: polyline,
      symbol: {
        type: "simple-line",
        color: [0, 255, 0, 1],
        width: 4
      }
    });

    view.graphics.add(lineGraphic);

    // ✅ Calculate distance
    const distance = calculateDistanceInKm(
      obj1.lat,
      obj1.lng,
      obj2.lat,
      obj2.lng
    );

    setDistance(distance.toFixed(2));

    // 🔹 Mid point for label
    const midLat = (obj1.lat + obj2.lat) / 2;
    const midLng = (obj1.lng + obj2.lng) / 2;

    const labelGraphic = new Graphic({
      geometry: {
        type: "point",
        latitude: midLat,
        longitude: midLng
      },
      symbol: {
        type: "text",
        text: `${distance.toFixed(2)} km`,
        color: "red",
        haloColor: "white",
        haloSize: "1px",
        font: {
          size: 14,
          weight: "bold"
        }
      }
    });

    view.graphics.add(labelGraphic);
  };
  const calculateDistanceInKm = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radius of earth in KM
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) *
      Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
  };
  //  CALCULATE
  //BHUPEN  CODE FOR SELECTED VALUE
  const handleFieldChange = async (opt, index) => {
    // Update the rows state
    const updated = [...rows];
    updated[index].field = opt?.value || ""; // OBJECTID
    setRows(updated);

    if (!map || !layerRef.current || !opt?.value) return;

    try {
      const layer = layerRef.current.sublayers.items[0];
      const layerUrl = layer.layer.url;
      const sublayerId = layer.id;

      // Query the feature by OBJECTID
      const queryUrl = `${layerUrl}/${sublayerId}/query?where=OBJECTID=${opt.value}&outFields=*&returnGeometry=true&f=json`;
      const response = await fetch(queryUrl);
      const data = await response.json();

      if (data.features && data.features.length > 0) {
        const feature = data.features[0];
        const geometry = feature.geometry;

        if (geometry) {
          // Zoom to the feature
          view.goTo({
            target: geometry,
            zoom: 17,
          });

          // ✅ Highlight the feature
          // Remove previous highlight
          if (highlightRef.current) {
            highlightRef.current.remove();
            highlightRef.current = null;
          }

          // Use FeatureLayer or sublayer's `View` highlight
          const featureLayer = layerRef.current.findSublayerById(sublayerId);
          highlightRef.current = featureLayer.highlight(feature.attributes);
        }
      }
    } catch (error) {
      console.error("Error highlighting feature:", error);
    }
  };
  //BHUPEN CODE FOR SELECTED VALUE

  // 18DEC  code for map div load

  useEffect(() => {
    const handleResize = () => {
      setIsScreenSize1(window.innerWidth <= 991)
    };
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])


  // handleTabClick code for 11DEC25

  const AdminLayer = (key) => {
    const filterExpr = buildFilter(districtCode, ulbCode, wardCode);

    if (view && layerRef.current) {
      view.graphics.removeAll();

      // view.map.removeAll();

      // code for Defualt Layers
      const newLayer = new MapImageLayer({
        url: mainLayerUrl,
        sublayers: [
          { id: 1, title: "State", visible: true, definitionExpression: filterExpr },
          { id: 3, title: "District", visible: true, definitionExpression: filterExpr },

        ]
      });
      view.map.add(newLayer);
      layerRef.current = newLayer;

      // code for Defualt Layers

    }
  };


  const handleTabClick = (key) => {
    // alert(token);

    console.log("handleTabClick key", key);

    const filterExpr = buildFilter(districtCode, ulbCode, wardCode);

    if (view && layerRef.current) {
      view.graphics.removeAll();
      view.map.removeAll();

      // code for Defualt Layers
      const newLayer = new MapImageLayer({
        url: mainLayerUrl,
        sublayers: [
          { id: 1, title: "State", visible: true, definitionExpression: filterExpr },
          { id: 3, title: "District", visible: true, definitionExpression: filterExpr },
          
        ]
      });
      view.map.add(newLayer);
      layerRef.current = newLayer;

      // code for Defualt Layers

    }
  };

  //  code for Second Layers





  // code for ADD DYANAMIC  and Condition 
  const [rows, setRows] = useState([
    { logical: "AND", field: "", operator: "", value: "" }
  ]);

  const addRow = () => {
    setRows([...rows, { field: "", operator: "", value: "" }]);
  };


  const removeRow = (index) => {
    setRows(rows.filter((_, i) => i !== index));
  };

  // Build Query Here 


  const buildQuery = () => {
    const conditions = rows
      .filter(row => row.field && row.operator && row.value) // ignore empty rows
      .map((row, index) => {
        const condition = `${row.field} ${row.operator} ${row.value}`;

        if (index === 0) {
          return `${condition}`;
        }
        return `${row.logical} ${condition}`;
      });

    return conditions.join(" ");
  };


  
  // Load Intial code for Second Layers
  useEffect(() => {

    

    const loadDistricts = async () => {

      const url = `${baseURL}/rest/services/temp_n/urbangis_temp/MapServer/3/query?where=1=1&outFields=districtname,dist_cd&returnGeometry=false&returnDistinctValues=true&f=geojson`;

      //alert(url);
      try {
        const response = await fetch(url);
        const data = await response.json();

        if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
          const userDistrict = [{
            districtName: authData.DistrictName,
            districtCode: authData.DistrictCode,
          }];
          setDistricts(userDistrict);
          setDistrictCode(authData.DistrictCode);
          setSelectedDistrict(authData.DistrictName);
          await loadUlbs(authData.DistrictCode);
        } else {
          const formatted = data.features.map(f => ({
            districtName: f.properties.districtname,
            districtCode: f.properties.dist_cd,
          }));
          setDistricts(formatted);
        }
      } catch (err) {
        console.error("Error loading districts:", err);
      }
    };


    if (!view) return;

    handleTabClick(0);
    if (selectedWard && wardCode && ulbCode) {
      zoomToWard(wardCode, ulbCode);
    } else if (selectedUlb && ulbCode) {
      zoomToUlb(selectedUlb);
    } else if (selectedDistrict && districtCode) {
      zoomToDistrict(selectedDistrict);
    }
    loadDistricts();
  }, [selectedDistrict, selectedUlb, selectedWard, districtCode, ulbCode, wardCode, authData, view]);

  const zoomToDistrict = async (districtName) => {
    const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/3')}` });
    const query = new Query({ where: `districtname = '${districtName}'`, returnGeometry: true });
    try {
      const { features } = await layer.queryFeatures(query);
      if (features.length) {
        const graphic = new Graphic({
          geometry: features[0].geometry,
          symbol: {
            type: "simple-fill",
            color: [0, 0, 255, 0.0],
            outline: { color: [0, 0, 255], width: 2 }
          }
        });
        view.graphics.add(graphic);
        view.goTo(features[0].geometry.extent.expand(1.0));
      }
    } catch (error) {
      console.error("Error zooming to district:", error);
    }
  };

  const zoomToUlb = async (ulbName) => {
    const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/94')}` });
    const query = new Query({ where: `ulbname = '${ulbName}'`, returnGeometry: true });

    try {
      const { features } = await layer.queryFeatures(query);
      if (features.length) {
        const graphic = new Graphic({
          geometry: features[0].geometry,
          symbol: {
            type: "simple-fill",
            color: [0, 0, 255, 0.0],
            outline: { color: [0, 0, 255], width: 2 }
          }
        });
        view.graphics.add(graphic);
        view.goTo(features[0].geometry.extent.expand(1.0));
      }
    } catch (error) {
      console.error("Error zooming to ULB:", error);
    }
  };

  const zoomToWard = async (wardCode, ulbCode) => {
    const layer = new FeatureLayer({ url: `${mainLayerUrl.replace('MapServer', 'FeatureServer/95')}` });
    const query = new Query({ where: `wardno = '${wardCode}' AND ulb_cd = '${ulbCode}'`, returnGeometry: true });

    try {
      const { features } = await layer.queryFeatures(query);
      if (features.length) {
        const graphic = new Graphic({
          geometry: features[0].geometry,
          symbol: {
            type: "simple-fill",
            color: [0, 0, 255, 0.0],
            outline: { color: [0, 0, 255], width: 2 }
          }
        });
        view.graphics.add(graphic);
        view.goTo(features[0].geometry.extent.expand(1.5));
      }
    } catch (error) {
      console.error("Error zooming to ward:", error);
    }
  };



  const loadUlbs = async (dist_cd) => {

    const url = `${baseURL}/rest/services/temp_n/urbangis_temp/MapServer/5/query?where=dist_cd='${dist_cd}'&returnGeometry=false&outFields=name,ulb_cd&returnDistinctValues=true&f=geojson`;


    try {
      const response = await fetch(url);
      const data = await response.json();
      if (authData?.UserType === "User") {
        const formattedUlbs = [{
          ulbName: authData?.UlbName,
          ulbCode: authData?.Ulb_Code,
        }];
        setUlbs(formattedUlbs);
        setUlbCode(authData?.Ulb_Code);
        setSelectedUlb(authData?.UlbName);
        await loadWards(authData?.Ulb_Code);
      } else if (data.features) {
        const formattedUlbs = data.features.map(f => ({
          ulbName: f.properties.name,
          ulbCode: f.properties.ulb_cd,
        }));
        setUlbs(formattedUlbs);
      }
    } catch (err) {
      console.error("Error loading ULBs:", err);
    }
  };

  const loadWards = async (ulb_cd) => {
    const url = `${baseURL}/rest/services/temp_n/urbangis_temp/MapServer/7/query?where=ulb_cd='${ulb_cd}'&returnGeometry=false&outFields=wardname,wardno&returnDistinctValues=true&f=geojson`;

    try {
      const response = await fetch(url);
      const data = await response.json();
      const formatted = data.features.map(f => ({
        wardName: f.properties.wardname,
        wardCode: f.properties.wardno,
        displayLabel: `${f.properties.wardno} - ${f.properties.wardname}`
      }));
      setWards(formatted);
    } catch (err) {
      console.error("Error loading wards:", err);
    }
  };

  const handleDistrictChange = async (selectedOption) => {
    if (!selectedOption) {
      handleRefresh();
      return;
    }
    const district = districts.find(d => d.districtCode === selectedOption.value);
    if (district) {
      setDistrictCode(district.districtCode);
      setSelectedDistrict(district.districtName);
      setUlbCode(""); setSelectedUlb(""); setWardCode(""); setSelectedWard("");
      await loadUlbs(district.districtCode);
      // fetchAndZoomPropertyChanges({ dist_cd: district.districtCode });
    }
  };

  const handleUlbChange = async (selectedOption) => {
    if (!selectedOption) {
      setUlbCode(""); setSelectedUlb(""); setWardCode(""); setSelectedWard("");
      // fetchAndZoomPropertyChanges({ dist_cd: districtCode }); // Refetch for the district
      return;
    }
    const ulb = ulbs.find(u => u.ulbCode === selectedOption.value);
    if (ulb) {
      setUlbCode(ulb.ulbCode); setSelectedUlb(ulb.ulbName); setWardCode(""); setSelectedWard("");
      await loadWards(ulb.ulbCode);
      // fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulb.ulbCode });
    }
  };

  const handleWardChange = async (selectedOption) => {
    if (!selectedOption) {
      setWardCode(""); setSelectedWard("");
      //  fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulbCode }); // Refetch for the ULB
      return;
    }
    const ward = wards.find(w => w.wardCode === selectedOption.value);
    if (ward) {
      setWardCode(ward.wardCode); setSelectedWard(ward.wardName);
      //  fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulbCode, wardno: ward.wardCode });
    }
  };



  // fetchAndZoomPropertyChanges and other helpers remain the same
  const fetchAndZoomPropertyChanges = async ({ dist_cd, ulb_cd, wardno }) => {

    //  await fetchPropertyData({ dist_cd, ulb_cd, wardno, page: 1 });
    const baseUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/abpas_property_mview/MapServer/1/query";
    const where = [dist_cd && `dist_cd='${dist_cd}'`, ulb_cd && `ulb_cd='${ulb_cd}'`, wardno && `wardno='${wardno}'`].filter(Boolean).join(" AND ") || "1=1";
    const url = `${baseUrl}?where=${encodeURIComponent(where)}&outFields=*&returnGeometry=true&f=json`;
    try {
      const response = await fetch(url);
      const json = await response.json();
      const graphics = json.features.map(f => new Graphic({
        geometry: { type: "polygon", rings: f.geometry.rings, spatialReference: { wkid: 102100 } },
        symbol: { type: "simple-fill", color: [255, 0, 0, 0.4], outline: { color: [255, 0, 0], width: 1 } },
        attributes: f.attributes
      }));
      if (graphics.length && view) {
        view.graphics.removeAll(); // Clear previous graphics
        view.graphics.addMany(graphics);
        await view.goTo(graphics);
      }
    } catch (err) {
      console.error("Error fetching property change data:", err);
    } finally {

    }
  };

  const handleRefresh = async () => {
    // Reset Map
    view.graphics.removeAll(); // Clear any highlights

    // Go to the initial extent or center
    view.goTo({
      center: [77.4126, 23.2599],
      zoom: 6,
      ui: { components: ["attribution"] }
    });




    // Reset all filter states
    setSelectedDistrict("");
    setDistrictCode("");
    setSelectedUlb("");
    setUlbCode("");
    setSelectedWard("");
    setWardCode("");


    // Reset dropdown options
    setUlbs([]);
    setWards([]);

    // Dispatch reset actions
    dispatch(setIsDist(""));
    dispatch(setIsUlb(""));
    dispatch(setIsWard(""));


    // Reset the map view to initial state

  };


  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      boxShadow: state.isFocused && !state.hasValue ? "0 0 0 1px #ccc" : "none",
      borderColor: state.isFocused && !state.hasValue ? "#ccc" : "#ccc",
      "&:hover": {
        borderColor: "#ccc",
      },
      fontSize: "12px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#d1ede9"
        : state.isFocused
          ? "#d1ede9"
          : "#FFFFFF",
      color: "#000",
      fontSize: "12px",
      padding: "10px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#000",
      fontSize: "12px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#000",
      fontSize: "12px",
    }),
    input: (provided) => ({
      ...provided,
      color: "#000",
      fontSize: "12px",
    }),
  };



  // code for map 
  const handleDrag = () => {
    setIsDrag(!isDrag)
  }
  const calculatedHeight = useMemo(() => {
    const hasFeatureTableData = setFeatureTable?.length > 0;
    if (isWidth && isByDefaultActive) {
      return "calc(100vh - 78px)"; // Adjust height as needed
    }
    if (isScreenSize1) {
      return tabLocation === "/user-chatbot" ? "calc(100vh - 200px)" : "calc(80vh - 78px)";
    }
    if (tabLocation) {
      return "calc(100vh - 78px)";
    }
    if (isDrag) {
      return "0px";
    }
    if (isWidth) {
      return hasFeatureTableData ? "calc(100vh - 285px)" : "calc(100vh - 78px)";
    }
    if (isWidth) {
      return "calc(100vh - 78px)"
    }
    if (!isWidth && hasFeatureTableData) {
      return isToolHeight ? "calc(100vh - 280px)" : "calc(100vh - 375px)";
    }
    if (!isWidth && hasFeatureTableData && isByDefaultActive) {
      return isToolHeight ? "calc(100vh - 108px)" : "calc(100vh - 375px)";
    }
    if (isBufferWidth && isToolHeight) {
      // return "calc(100vh - 110px)"
      return "calc(100vh - 330px)"
    }
    if (isToolHeight) {
      return "calc(100vh - 330px)"
    }

    return "calc(100vh - 425px)";
  }, [tabLocation, isDrag, isWidth, setFeatureTable, isBufferWidth, isScreenSize, isScreenSize1, isByDefaultActive, isToolHeight]);

  // BHUPEN CODE FOR MAP MAXIMIZE

  const [isMaximized, setIsMaximized] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const MAP_BUTTON_STYLES = {
    base: {
      padding: "4px 8px",
      border: "none",
      borderRadius: "4px",
      color: "white",
      fontWeight: 200,
      cursor: "pointer",
      transition: "all 0.3s ease",
    },
    maximize: {
      backgroundColor: "#04595c",
    },
    minimize: {
      backgroundColor: "#026b83",
    },
  };
  const toggleMaximize = () => {
    setIsMaximized(prev => !prev);
  };
  // BHUPEN CODE FOR MAP MAXIMIZE

  // Two Points  CODE FOR HIGHT

  const highlightLayerRef = useRef(null);
  useEffect(() => {
    if (!map || highlightLayerRef.current) return;

    const highlightLayer = new GraphicsLayer({
      title: "Highlight Layer"
    });

    map.add(highlightLayer); // Add once
    highlightLayerRef.current = highlightLayer;

  }, [map]);

  const highlightRef1 = useRef(null);
  const highlightRef2 = useRef(null);

  const blinkRef1 = useRef(null);
  const blinkRef2 = useRef(null);


  if (blinkRef1.current) {
    clearInterval(blinkRef1.current);
    blinkRef1.current = null;
  }

  // code for one1 
  const highlightLocation1 = (row) => {
    if (!view || !row || !highlightLayerRef.current) return;

    if (highlightRef1.current) {
      highlightLayerRef.current.remove(highlightRef1.current);
    }

    if (blinkRef1.current) {
      clearInterval(blinkRef1.current);
    }

    const graphic = new Graphic({
      geometry: {
        type: "point",
        longitude: row.lng,
        latitude: row.lat
      },
      symbol: {
        type: "simple-marker",
        style: "circle",
        color: [0, 255, 0, 0.4],
        size: 30,
        outline: {
          color: "green",
          width: 3
        }
      }
    });

    highlightLayerRef.current.add(graphic);
    highlightRef1.current = graphic;

    let visible = true;

    blinkRef1.current = setInterval(() => {
      if (!highlightRef1.current) return;
      visible = !visible;
      highlightRef1.current.visible = visible;
    }, 500);
  };

  const highlightLocation2 = (row) => {
    if (!view || !row) return;

    // Remove old red only
    if (highlightRef2.current) {
      view.graphics.remove(highlightRef2.current);
      clearInterval(blinkRef2.current);
    }

    const graphic = new Graphic({
      geometry: {
        type: "point",
        longitude: row.lng,
        latitude: row.lat
      },
      symbol: {
        type: "simple-marker",
        style: "circle",
        color: [255, 0, 0, 0.4],
        size: 30,
        outline: {
          color: "red",
          width: 3
        }
      }
    });

    view.graphics.add(graphic);
    highlightRef2.current = graphic;

    let visible = true;

    blinkRef2.current = setInterval(() => {
      if (!highlightRef2.current) return;
      visible = !visible;
      highlightRef2.current.visible = visible;
    }, 500);
  };




  // CODE FOR HIGHT



  const handleToggleBufferWidth = () => {
    // dispatch(setIsBufferWidth(!isBufferWidth));
    console.log("left")
  };
  const handleToggleBufferLeft = () => {
    // dispatch(setIsSidebar(!isSideBar));
  };
  return (
    <>
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          overflow: "hidden",
        }}
      >

        {/* ================= MAP SECTION ================= */}
        <div
          style={{
            flex: 1,
            position: "relative",
            transition: "all 0.3s ease",
          }}
        >

          {/* Maximize Button */}
          <div style={{ position: "absolute", top: "15px", right: "20px", zIndex: 999 }}>
            <button
              onClick={toggleMaximize}
              style={{
                padding: "6px 14px",
                fontSize: "13px",
                borderRadius: "20px",
                border: "none",
                cursor: "pointer",
                color: "white",
                boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                background: "#108181",
              }}
            >
              {isMaximized ? "Minimize Map" : "Maximize Map"}
            </button>
          </div>

          <div
            ref={mapDiv}
            style={{
              width: "100%",
              height: "100%",
            }}
          />

        </div>

        {/* ================= RIGHT PANEL ================= */}
        {!isMaximized && (
          <div
            style={{
              width: "440px",          // 👈 control sidebar width here
              minWidth: "300px",
              maxWidth: "460px",
              background: "#108181",
              padding: "15px",
              overflowY: "auto",
              boxShadow: "-3px 0 8px rgba(0,0,0,0.1)",
              height: "100vh",
            }}
          >

            {/* Your panel content here */}

            {/* DIV RIGHT  */}
            <div>
              <div className='tooltitlediv linear-gradian-bg d-flex justify-content-between align-items-center px-3'>
                <h6 className='sidebarbuttontitle text-white m-0'>MAP Point Distance Analysis </h6>
                {/* Refresh Button */}
                <button
                  style={{
                    borderRadius: "4px",
                    padding: "6px 12px",
                    border: "1px solid #ccc",
                    backgroundColor: "#046168",
                    color: "#fff",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                  onClick={() => window.location.reload()}
                >
                  <span style={{ display: "inline-block" }}>🔄</span>
                  Refresh
                </button>
              </div>
              {/*<div className="tabs-container d-flex justify-content-between mt-3">
              <button className={`tab-btn ${activeSelect === "area" ? "active" : ""}`} onClick={() => setActiveSelect("area")}>   Filters </button>
              <button className={`tab-btn ${activeSelect === "layer" ? "active" : ""}`} onClick={() => setActiveSelect("layer")} >Layers</button>
            </div> */}
              <div className='col-lg-11 col-md-12 p-lg-8 mt-2 ' >
                {/* // code for panel // */}
                <div   >
                  {activeSelect === "area" ?
                    <>
                      <div
                        style={{
                          background: "linear-gradient(90deg, rgba(174, 203, 214, 1) 0%, rgba(221, 236, 227, 1) 50%, rgba(245, 245, 245, 1) 100%)",

                          borderRadius: "4px", overflow: "auto"
                        }}>
                        <Select
                          options={districts.map((d) => ({ value: d.districtCode, label: d.districtName })).sort((a, b) => a.label.localeCompare(b.label))}
                          value={districtCode ? { value: districtCode, label: selectedDistrict } : null}
                          onChange={(selectedOption) => !selectedOption ? handleRefresh() : handleDistrictChange(selectedOption)}
                          styles={customStyles} placeholder="Select District" isClearable={true} className="mt-3"
                          isDisabled={authData?.UserType === "districtuser" || authData?.UserType === "User"}
                        />
                        <Select
                          options={ulbs.map((u) => ({ value: u.ulbCode, label: u.ulbName })).sort((a, b) => a.label.localeCompare(b.label))}
                          value={ulbCode ? { value: ulbCode, label: selectedUlb } : null}
                          onChange={handleUlbChange} placeholder="Select ULB" isClearable={true}
                          isDisabled={authData?.UserType === "districtuser" || authData?.UserType === "User" || !districtCode} className="mt-3" styles={customStyles}
                        />
                        {/* <Select
                        options={wards.map((w) => ({ value: w.wardCode, label: w.displayLabel })).sort((a, b) => Number(a.value) - Number(b.value))}
                        value={wardCode ? { value: wardCode, label: wards.find(w => w.wardCode === wardCode)?.displayLabel } : null}
                        onChange={handleWardChange} placeholder="Select ward" isClearable={true} isDisabled={!ulbCode} className="mt-3" styles={customStyles}
                      /> */}
                        <div
                          id="DivQuery"
                          style={{
                            backgroundColor: "#ffffff",
                            marginTop: "12px",
                            borderRadius: "8px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                            overflowY: "auto",
                            padding: "18px"
                          }}
                        >
                          {/* ---------------- WATER SECTION ---------------- */}
                          <div
                            style={{
                              background: "linear-gradient(90deg,#066853,#0a8f73)",
                              color: "white",
                              padding: "10px 14px",
                              borderRadius: "6px",
                              fontWeight: "600",
                              fontSize: "14px"
                            }}
                          >
                            Industrial  Layer Selection
                          </div>

                          <div style={{ marginTop: "18px" }}>
                            {/* Row 1 */}
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "14px" }}>
                              <label style={{
                                fontWeight: "600", fontSize: "14px"
                              }}>
                                Select Layer
                              </label>

                              <select
                                onChange={handleLayerChange}
                                style={{

                                  padding: "8px",
                                  fontSize: "13px",
                                  border: "1px solid #ccc",
                                  borderRadius: "6px",
                                  backgroundColor: "#f9f9f9"
                                }}
                              >
                                <option value="">-- Select Layer --</option>
                                <option value="industrial_area_location">industrial_area_location  Distance Analysis</option>
                              </select>
                            </div>

                            {/* Row 2 */}
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <label style={{
                                fontWeight: "600", fontSize: "14px"
                              }}>
                                Select Point
                              </label>
                              {/*SELEECT ONE POITS */}
                              <select
                                value={selectedValue1}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setSelectedValue1(value);

                                  const selectedObj = fieldsOptions.find(
                                    (o) => o.value === Number(value)
                                  );

                                  if (selectedObj) {
                                    highlightLocation1(selectedObj); // 🔥 Green Blink
                                  }
                                }}
                                style={{
                                  width: "240px",
                                  padding: "8px",
                                  fontSize: "13px",
                                  border: "1px solid #ccc",
                                  borderRadius: "6px",
                                  backgroundColor: "#f9f9f9"
                                }}
                              >
                                <option value="">Select Industrial Location </option>
                                {fieldsOptions.map((option) => (
                                  <option key={option.value} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                              </select>

                            </div>
                          </div>

                          {/* ---------------- STP SECTION ---------------- */}
                          <div
                            style={{
                              background: "linear-gradient(90deg,#066853,#0a8f73)",
                              color: "white",
                              padding: "10px 14px",
                              borderRadius: "6px",
                              fontWeight: "600",
                              fontSize: "14px",
                              marginTop: "30px"
                            }}
                          >
                            STP Layer Selection
                          </div>

                          <div style={{ marginTop: "18px" }}>
                            {/* Row 1 */}
                            <div style={{ display: "flex", alignItems: "center", marginBottom: "14px" }}>
                              <label style={{ width: "140px", fontWeight: "600", fontSize: "14px" }}>
                                Select STP Layer
                              </label>

                              <select
                                onChange={handleLayerChange2}
                                style={{
                                  width: "240px",
                                  padding: "8px",
                                  fontSize: "13px",
                                  border: "1px solid #ccc",
                                  borderRadius: "6px",
                                  backgroundColor: "#f9f9f9"
                                }}
                              >
                                <option value="">-- Select Layer --</option>
                                <option value="SewerSTP">SewerSTP</option>
                              </select>
                            </div>

                            {/* Row 2 */}
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <label style={{ width: "140px", fontWeight: "600", fontSize: "14px" }}>
                                Select STP Point
                              </label>
                              {/*SELEECT Second POINTS */}
                              <select
                                value={selectedValue2}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  setSelectedValue2(value);
                                  const selectedObj = fieldsOptions2.find(
                                    (o) => o.value === Number(value)
                                  );
                                  if (selectedObj) {
                                    highlightLocation2(selectedObj); // Red Blink
                                  }
                                }}
                                style={{
                                  width: "240px",
                                  padding: "8px",
                                  fontSize: "13px",
                                  border: "1px solid #ccc",
                                  borderRadius: "6px",
                                  backgroundColor: "#f9f9f9"
                                }}
                              >
                                <option value="">Select STP Location </option>
                                {fieldsOptions2.map((option) => (
                                  <option key={option.value} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            marginTop: "10px",
                            backgroundColor: "#cad7d4ff",
                            height: "50px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "5px"   // space between buttons
                          }}
                        >
                          <button
                            className="btn text-white"
                            onClick={handleRunQuery}
                            style={{
                              width: "250px",
                              backgroundColor: "#0c7b7bff",
                              border: "1px solid #034747ff",
                            }}
                          >
                            Submit
                          </button>
                        </div>
                        <div style={{ backgroundColor: "#066853ff", color: "white", height: "5px" }}>
                          <h6 style={{ paddingTop: "5px", paddingLeft: "5px" }} ><b>
                          </b>
                          </h6>
                        </div>
                        <center>  <b> Total  Distance  </b></center>
                        <div style={{ backgroundColor: "#066853ff", color: "white", height: "5px" }}>
                          <h6 style={{ paddingTop: "5px", paddingLeft: "5px" }} ><b>
                          </b>
                          </h6>
                        </div>
                        <div style={{
                          textAlign: "center",
                          padding: "8px",
                          fontSize: "13px",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                          backgroundColor: "#f9f9f9",
                          height: "200px"
                        }}>

                          <div
                            style={{
                              marginTop: "10px",
                              padding: "10px",
                              border: "1px solid #ddd",
                              borderRadius: "6px",
                              background: "#eef6ff",
                              fontSize: "14px"
                            }}
                          >
                            {INDSelected && STPSelected ? (
                              <div>
                                📍 <b>{INDSelected}</b>
                                <br />

                                🗺️ <b>{STPSelected}</b>
                                <br />
                                📏 Distance: <h2>{distance ? distance + " km" : "Calculating..."}</h2>
                              </div>
                            ) : (
                              <div>Please select both location and layer</div>
                            )}
                          </div>


                        </div>




                      </div>
                    </>
                    :
                    activeSelect === "propertyinfo" ?
                      <>
                        {/* {Bhupen Propertytab} */}


                      </>
                      :
                      <div className='col-lg-12 col-md-12 p-lg-8 px-3 '>
                        <div className={'scroll-layerdiv'} style={{ height: "600px" }} >
                          <LayerControlPanel groups={layerGroups} toggleLayer={toggleLayer} />
                        </div>
                      </div>
                  }
                </div>
              </div>    </div>
            {/* DIV RIGHT SIDE*/}

            {/* 123 Your panel content here */}

          </div>
        )}
      </div>
    </>
  )
}
export default MapPointDist 